import React, { useState } from "react";
import "./admin.css";
import FAQ from '../images/faqColoured.png';
import Footer from "../components/Footer";
import { useEffect } from 'react';
import { Helmet } from "react-helmet";
import useAdmin from "../hooks/useAdmin"
import NewUser from './newUser';

const AdminPage = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    // Get list of all registered users using useAdmin hook
    const { userList, fetchUsers, deleteUser } = useAdmin();
  
    // const users = [
    //   "Patient 1",
    //   "Patient 2",
    //   "Patient 3",
    //   "Patient 4",
    //   "Patient 5",
    //   "Patient 6",
    //   "Patient 7",
    //   "Patient 8",
    // ];
  
    return (
      <div>
        <Helmet>
          <title>Admin | ENT Chatbot</title>
        </Helmet>
        <div className="admin-box">
        <div className="admin-header">
          <img src={FAQ} className="iconAdminFAQ" />
          <div className= "content">
            <h1> Administration </h1>
          </div>
          
        </div>
        <h2 className= "subheading-text-admin"> View and manage current users </h2>
        <div className= "line-admin">
          <hr></hr>
        </div>
        <div className= "new-user-button">
          <form action = './newUser'> 
            <button className="new-button" type='submit'> Add New User </button>
          </form>
        </div>
        <ul className= "list">
          {Array.isArray(userList) && userList.map((currentUser, user) => (
            <li key={user} className="patient-box">
              <h2 className={`patient`}>
                {currentUser}
                <button className= "manage-button" 
                  onClick={() => {
                      const confirmDelete = window.confirm(`Are you sure you want to delete "${currentUser}"?`);
                      if (confirmDelete) {
                        deleteUser(currentUser);
                      }
                  }}> 
                  Delete Account
                </button>
              </h2>
            </li>
          ))}
        </ul>
        </div>
        <Footer/>
      </div>
    );
  };
  
export default AdminPage;